import { useStaticQuery, graphql } from 'gatsby';
import React from 'react';
import Search from '../../molecules/search';
import { FilteredItem } from '../../molecules/search';

function removeNewLine(value: string) {
  return value
    .replace(/<br>/g, '')
    .replace(/<br \/>/g, '')
    .replace(/<br\/>/g, '');
}

interface Props {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const SiteSearch: React.FC<Props> = ({ open, setOpen }) => {
  const [query, setQuery] = React.useState('');
  const searchData = useStaticQuery<Queries.Query>(
    graphql`
      query SearchData {
        allMarkdownRemark(limit: 1000) {
          edges {
            node {
              fields {
                slug
              }
              frontmatter {
                title
              }
              rawMarkdownBody
            }
          }
        }
        allParamJson {
          edges {
            node {
              paramName
              paramValue
            }
          }
        }
      }
    `,
  );
  const searchItems: FilteredItem[] = React.useMemo(() => {
    return searchData.allMarkdownRemark.edges.map((e: any) => {
      const params = searchData.allParamJson.edges
        .filter((x: any) => {
          return e.node.rawMarkdownBody.includes(x.node.paramName);
        })
        .map((x: any) => {
          return x.node.paramValue;
        })
        .join();

      return {
        title: e.node.frontmatter.title,
        body: e.node.rawMarkdownBody + params,
        href: `/docs/${String(
          e.node.fields?.slug.replace(/\/$/, '').split('/').pop(),
        )}`,
      };
    });
  }, []);
  const filteredItems =
    query !== ''
      ? searchItems.filter((item: FilteredItem) => {
          const target = `
        ${item.title.toLowerCase()}
        ${removeNewLine(item.body.toLowerCase())}
        `;
          return target.toLowerCase().includes(query.toLowerCase());
        })
      : [];

  return (
    <Search
      open={open}
      setOpen={setOpen}
      query={query}
      setQuery={setQuery}
      filteredItems={filteredItems}
    />
  );
};

SiteSearch.displayName = 'SiteSearch';

export default SiteSearch;
